import vars from './helpers';
import Share from './vendor/ninelines-sharing';

let $socialButtons = $('.social__buttons');

$('[data-social]').on('click', (e) => {
	let social = $(e.currentTarget).data('social');
	let url = location.href;

	Share[social](url);
});

$('[data-copy]').on('click', (e) => {
	let $current = $(e.currentTarget);
	let $temp = $('<input>');
	let $span = $('.social__span');

	$('body').append($temp);
	$temp.val(location.href).select();
	document.execCommand('copy');
	$temp.remove();

	$current.css('transform', 'rotate(180deg)')

	if ($current.attr('style')) {
		setTimeout(() => {
			$current.removeAttr('style');
		}, 300);
	}

	if (!$span.hasClass('is-active')) {
		$span.addClass('is-active').fadeIn(150, () => {
			$span.fadeOut(1000, () => {
				$span.removeClass('is-active');
			});
		});
	}
});



$(window).on('scroll', () => {
	if ($socialButtons.hasClass('is-active')) {
		$socialButtons.removeClass('is-active');
	}
})

function socialButtons() {
	if (!vars.isMobile()) {
		return;
	}

	$('[data-more]').on('click', () => {
		$socialButtons.addClass('is-active');
	});

	$socialButtons.find('.social__button').on('click', () => {
		if ($socialButtons.hasClass('is-active')) {
			setTimeout(() => {
				$socialButtons.removeClass('is-active');
			}, 1000);
		}
	});
}

socialButtons();
